import { DEFAULT_COLOR, DEFAULT_WIDTH, ERASER_COLOR, ERASER_WIDTH } from '@panels/shared';
import type { Pen } from './drawing.js';

/**
 * The drawing tools, as data. Each is just a pen (guardrail #2: style travels
 * with every stroke), so adding one — a colour swatch, a thicker marker — is a
 * new entry here and nothing else. Text will be a different kind of op when it
 * comes, and will need more than an entry.
 */
export type ToolId = 'pen' | 'eraser';

export interface Tool {
  id: ToolId;
  label: string;
  pen: Pen;
}

export const TOOLS: Tool[] = [
  { id: 'pen', label: 'Pen', pen: { color: DEFAULT_COLOR, width: DEFAULT_WIDTH } },
  { id: 'eraser', label: 'Eraser', pen: { color: ERASER_COLOR, width: ERASER_WIDTH } },
];
